import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Button from "../components/button";
import Card from "../components/card";
import { BackgroundImage, BackgroundWrap, CardsWrap, SectionTitle, SectionWrap } from "./servers.style";

const ServersSection = ({ servers, background }) => {
    return (
        <BackgroundWrap>
            <BackgroundImage image={background.childImageSharp.gatsbyImageData} alt="Background" />
            <SectionWrap>
                <SectionTitle>
                    <h1>Modded Minecraft Network</h1>
                    <h2>Checkout our modpack servers</h2>
                </SectionTitle>

                <CardsWrap>
                    {Object.entries(servers)
                        // sort in descending order
                        .sort(([, a], [, b]) => {
                            if (a.frontmatter.order < 0) return 1;
                            if (b.frontmatter.order < 0) return -1;
                            return b.frontmatter.order - a.frontmatter.order;
                        })
                        .map(([index, server]) => (
                            <Card
                                key={`content_item_${index}`}
                                title={server.frontmatter.name}
                                icon={server.icon}
                                link={server.fields.slug}
                            />
                        ))}
                </CardsWrap>

                <Button path="#download" style={{ margin: "50px 0" }}>
                    Play Now!
                </Button>
            </SectionWrap>
        </BackgroundWrap>
    );
};

ServersSection.propTypes = {
    servers: PropTypes.arrayOf(PropTypes.shape({})),
    background: PropTypes.object,
};

export default ServersSection;
